<template>
  <AppTreeView initially-expanded>
    <template #root>
      <v-checkbox hide-details
                  :model-value="areAllSignedDocumentsSelected"
                  :indeterminate="areSomeSignedDocumentsSelected"
                  @click="selectAllClick"
      >
        <template #label>
          {{ $t('project.signed-documents.SignedDocumentsSelector.rootLabel') }}
        </template>
      </v-checkbox>
    </template>

    <template #children>
      <div v-for="signedDocument in signedDocuments"
           :key="signedDocument.id"
      >
        <label :for="`signedDocument_${signedDocument.id}`"
               class="d-flex align-center justify-space-between"
        >
          <v-checkbox
            :id="`signedDocument_${signedDocument.id}`"
            hide-details
            :model-value="isSignedDocumentSelected(signedDocument)"
            @update:model-value="toggleSignedDocumentSelection(signedDocument)"
          >
            <template #label>{{ signedDocument.name }}</template>
          </v-checkbox>

          <span v-if="signedDocument.time && $vuetify.display.smAndUp"
                class="text--x-small"
          >
            {{ `${$t('project.bibles.dialogs.BibleGenerateDialog.myOrigSignedOn')} ${formatSignTime(signedDocument.time)}` }}
        </span>
        </label>
      </div>
    </template>
  </AppTreeView>
</template>

<script lang="ts">
import dayjs from 'dayjs'
import { defineComponent, PropType } from 'vue'

import AppTreeView from '@/common/AppTreeView.vue'
import { useSelection } from '@/common/selection/useSelection'

type SignedDocument = {
  id: number;
  name: string;
  time: string;
}

export default defineComponent({
  name: 'SignedDocumentsSelector',
  emits: ['update:selectedSignedDocuments'],
  components: { AppTreeView },
  setup (props) {
    const {
      areAllItemsSelected: areAllSignedDocumentsSelected,
      areSomeItemsSelected: areSomeSignedDocumentsSelected,
      isItemSelected: isSignedDocumentSelected,
      toggleItemSelection: toggleSignedDocumentSelection,
      selectedItems,
      selectAllItems,
      unselectAllItems,
    } = useSelection<SignedDocument>({
      items: props.signedDocuments,
      initialSelection: props.selectedSignedDocuments,
    })

    return {
      areAllSignedDocumentsSelected,
      areSomeSignedDocumentsSelected,
      isSignedDocumentSelected,
      toggleSignedDocumentSelection,
      selectedItems,
      selectAllItems,
      unselectAllItems,
    }
  },
  props: {
    signedDocuments: {
      type: Array as PropType<Array<SignedDocument>>,
      default: () => [],
    },
    selectedSignedDocuments: {
      type: Array as PropType<Array<SignedDocument>>,
      default: () => [],
    },
  },
  watch: {
    selectedItems: {
      handler (newValue) {
        this.$emit('update:selectedSignedDocuments', newValue)
      },
      // NOTE: didn't find a better solution. This seems weird to me. If we can use something other than deep
      // to actually watch right from the beginning, it'd be great
      deep: true,
    },
  },
  methods: {
    formatSignTime (signatureDate: string) {
      return dayjs(signatureDate).format(`DD/MM/YYYY [${this.$t('common.at')}] HH:mm:ss`)
    },
    selectAllClick () {
      if (this.areAllSignedDocumentsSelected) {
        this.unselectAllItems()
      } else {
        this.selectAllItems()
      }
    },
  },
})
</script>
